import { getPreciseSubtraction } from "./math";
import { i18n } from "../helpers/i18n";
import { currencyFormatWithDecimalPlaces } from "../formatters/currency-adapter";
import type { BetslipLocalization } from "../contract";

const NOT_AVAILABLE_KEY = "I18N.BETSLIP.NOT_AVAILABLE";

export type BalanceAfterBetLabelConfig = {
  accountBalance: number;
  totalStake: number;
  isOldUseBonusActive?: boolean;
  isLoggedIn?: boolean;
};

export const buildSbkBalanceAfterBetLabel = (
  localization: BetslipLocalization,
  { accountBalance, totalStake, isOldUseBonusActive = false, isLoggedIn }: BalanceAfterBetLabelConfig,
): string => {
  if (isOldUseBonusActive) {
    return i18n({ key: NOT_AVAILABLE_KEY });
  }

  const newAccountBalance = isLoggedIn ? getPreciseSubtraction(accountBalance, totalStake) : 0;

  return newAccountBalance >= 0
    ? currencyFormatWithDecimalPlaces({
        ...localization,
        value: newAccountBalance,
      })
    : i18n({ key: NOT_AVAILABLE_KEY });
};
